module.exports = __webpack_public_path__ + "img/icon_2_16.a3292999.png";